import loginSlice from "./slices/loginSlice.js";
import userSlice from "./slices/user.js";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers, configureStore } from "@reduxjs/toolkit";

const persistConfig = {
  key: 'prediction',
  blacklist: ['userSlice'],
  version: 1,
  storage,
}

const rootReducer = combineReducers({
  loginSlice: loginSlice,
  userSlice: userSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)



export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export let persistor = persistStore(store)
